<script lang="ts">
  import type { ClassValue } from "svelte/elements";

  interface Props {
    dashed?: boolean;
    vertical?: boolean;
    class?: ClassValue;
  }

  let { dashed = false, vertical = false, class: className, ...rest }: Props = $props();
</script>

<svg
  aria-hidden="true"
  {...rest}
  class={["shrink-0", vertical ? "h-full w-px" : "h-px w-full", className]}
>
  <line
    x1={vertical ? "1" : "0"}
    x2={vertical ? "1" : "100%"}
    y1={vertical ? "0" : "1"}
    y2={vertical ? "100%" : "1"}
    stroke="var(--color-border)"
    stroke-width="2"
    stroke-dasharray={dashed ? "4,2" : undefined}
    vector-effect="non-scaling-stroke"
  />
</svg>
